import React, { useEffect, useState } from 'react';

const WarningList = ({ title, note, items }) =>
  items?.length ? (
    <div className="px-3 pb-2">
      <div className="fw-semibold">{title}</div>
      <div className="small text-muted">{note}</div>
      <ul>
        {items.map((name, i) => (
          <li key={`${name}-${i}`}>{name}</li>
        ))}
      </ul>
    </div>
  ) : null;

const ColumnWarnings = ({ unmappedColumns, missingColumns }) => {
  const hasMissing = missingColumns?.length > 0;
  const hasAny = hasMissing || unmappedColumns?.length > 0;
  // Missing columns change the result, so that panel opens by default.
  const [open, setOpen] = useState(hasMissing);

  useEffect(() => {
    setOpen(hasMissing);
  }, [hasMissing, unmappedColumns, missingColumns]);

  if (!hasAny) return null;

  return (
    <div className="bv-warnings mb-3">
      <div className="bv-warnings-head" onClick={() => setOpen((o) => !o)}>
        {open ? '▾' : '▸'} Column warnings ({(unmappedColumns?.length || 0) + (missingColumns?.length || 0)})
      </div>
      {open ? (
        <>
          <WarningList
            title="Headings we did not recognise"
            note="These columns in the file were ignored."
            items={unmappedColumns}
          />
          <WarningList
            title="Columns with no heading in the file"
            note="These were left empty. If one of them matters, the bank changed its layout."
            items={missingColumns}
          />
        </>
      ) : null}
    </div>
  );
};

export default ColumnWarnings;
